import onDOMContentLoaded from '../../base/util/dom/onDOMContentLoaded';
import {StatisticsHandler} from "./statistics-handler";

onDOMContentLoaded(() => {
    const statisticsElement = document.querySelector('.dws__account-statistics');
    if (statisticsElement instanceof HTMLElement) {
        new StatisticsHandler(statisticsElement);
    }
});
